import { render, staticRenderFns } from "./myopiaHazard.vue?vue&type=template&id=0f0442d1&scoped=true&"
import script from "./myopiaHazard.vue?vue&type=script&lang=js&"
export * from "./myopiaHazard.vue?vue&type=script&lang=js&"
import style0 from "./myopiaHazard.vue?vue&type=style&index=0&id=0f0442d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0442d1",
  null
  
)

export default component.exports